import React from 'react';
import UpdateBookmarkPage from '../updateUserProject';

const DenyUserProjectPage = () => <UpdateBookmarkPage status='rejected' />;

export default DenyUserProjectPage;
